import { defineStore } from "pinia";
import { ref } from "vue";
import type { RichTextContext } from "@plugins/richtext/types.ts";

export interface PdfCaptureOpenParams {
  pdfUrl: string;
  pdfFilename: string;
  mediaObjectUuid: string;
  // KB capture context — omit for view-only mode
  resourceType?: string;
  resourceId?: number;
  currentKbCount?: number;
  maxKbAllowed?: number;
  richTextContext?: RichTextContext | null;
  onImageSaved?: (kbEntry: unknown) => void;
}

export const usePdfCaptureStore = defineStore("pdfCapture", () => {
  const activeCapture = ref<PdfCaptureOpenParams | null>(null);

  function open(params: PdfCaptureOpenParams): void {
    activeCapture.value = params;
  }

  function close(): void {
    activeCapture.value = null;
  }

  return { activeCapture, open, close };
});
